module.exports = __webpack_public_path__ + "static/pic19-3387a1f74d8ff84c4973f5d339fe93be.png";